'use es6';

import createRequestClient from 'ContentEditorUI/utils/createRequestClient';
import getLang from 'I18n/utils/getLang';
const GLOBAL_MODULES_URL = 'content/api/v4/widgets/list-summaries';
export const fetchContentSchema = () => {
  const {
    contentId
  } = window.parseEditorUrl();
  const language = getLang();
  return createRequestClient(`content-editor/v1/combined-edit-data/${contentId}`, {
    timeout: 30000,
    query: {
      userLanguage: language,
      hsEditorApp: 'blog',
      serializeModulesInRichText: true
    }
  }, 'content')();
};
export const fetchGlobalModules = createRequestClient(GLOBAL_MODULES_URL, {}, 'globalModules');